import API from "@/API";

const SET_ORDERS = "SET_ORDERS";
const SET_LOADER = "SET_LOADER";
const SET_TOTAL_ITEMS = "SET_TOTAL_ITEMS";
const SET_PAGE = "SET_PAGE";
const SET_PAGE_SIZE = "SET_PAGE_SIZE";
const SET_PAGINATION = "SET_PAGINATION";
const SET_SORT_FIELD = "SET_SORT_FIELD";
const SET_TEXT_SEARCH = "SET_TEXT_SEARCH";

export default {
  namespaced: true,

  state: {
    orders: [],
    pagination: {
      ascending: false,
      descending: true,
      page: 1,
      rowsPerPage: 25,
      sortBy: "created_at"
    },
    totalItems: 0,
    textSearch: "",
    loader: false
  },

  actions: {
    async getOrders({ state, commit }, user) {
      commit("SET_LOADER", true);

      try {
        commit("SET_ORDERS", []);
        let opts = {
          pagination: state.pagination,
          textSearch: state.textSearch,
          user
        };

        let results = await API.Orders.index(opts);
        commit("SET_TOTAL_ITEMS", results.totalItems);
        commit("SET_ORDERS", results.data);
      } catch (e) {
        commit("SET_LOADER", false);
        throw "Não foi possivel filtrar os pedidos!";
      }

      commit("SET_LOADER", false);
    },

    setPagination({ commit, dispatch }, payload) {
      commit("SET_PAGINATION", payload.value);
      dispatch("getOrders", payload.user);
    },

    setTextSearch({ commit, dispatch }, payload) {
      try {
        let { value, user } = payload;

        if (value.length != "" && value.length < 3) {
          dispatch(
            "snackbar/snackbarError",
            "O texto de busca deve conter no mínimo 3 caracteres",
            {
              root: true
            }
          );
          return;
        }

        commit("SET_TEXT_SEARCH", value);
        dispatch("setPage", 1);
        dispatch("getOrders", user);
      } catch (error) {}
    },

    setPage({ commit }, payload) {
      commit("SET_PAGE", payload);
    },

    async getById({ state }, id) {
      try {
        return await API.Orders.getById(id);
      } catch (error) {
        throw error;
      }
    },

    async getByEvent({ state }, eventID) {
      try {
        return await API.Orders.getByEvent(eventID);
      } catch (error) {
        throw error;
      }
    },

    async cancel({ state }, id) {
      try {
        return await API.Orders.cancel(id);
      } catch (error) {
        throw error;
      }
    },

    async confirmPayment({ state }, id) {
      try {
        return await API.Orders.confirmPayment(id);
      } catch (error) {
        throw error;
      }
    },

    async updateDescription({ state }, order) {
      try {
        return await API.Orders.updateDescription(order);
      } catch (error) {
        throw error;
      }
    },

    async setServiceNotProvided({ state }, id) {
      try {
        return await API.Orders.setServiceNotProvided(id);
      } catch (error) {
        throw error;
      }
    },

    async restoreOrderToPaid({}, orderId) {
      try {
        return await API.Orders.restoreOrderToPaid(orderId);
      } catch (error) {
        throw error;
      }
    }
  },

  mutations: {
    [SET_ORDERS](state, payload) {
      state.orders = payload;
    },
    [SET_LOADER](state, payload) {
      state.loader = payload;
    },
    [SET_TOTAL_ITEMS](state, payload) {
      state.totalItems = payload;
    },
    [SET_PAGE](state, payload) {
      state.pagination.page = payload;
    },
    [SET_PAGE_SIZE](state, payload) {
      state.pagination.size = payload;
    },
    [SET_PAGINATION](state, payload) {
      state.pagination = payload;
    },
    [SET_TEXT_SEARCH](state, payload) {
      state.textSearch = payload;
    }
  },

  getters: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/orders.js